<template>
  <div class="page">
    <header-bar>
      <span slot="left"></span>
      <span>{{ $t("system.SetBinding") }}{{ $t("Categorys." + AuthCode) }}{{ Step }}/{{ TotalStep }}</span>
    </header-bar>
    <div class="page-content">
      <div class="BindingAccount">
        <div class="BindingAccount-wrapper" v-if="Step == 1">
          <div class="BindingAccount-title">{{ $t("system.Input") }}{{ $t("Categorys." + AuthCode) }}</div>
          <div class="BindingAccount-account">
            <input type="text" v-model="models.UserAct" :placeholder="$t('system.Effective') + ' ' + $t('Categorys.' + AuthCode)" />
          </div>
          <div class="border_bottom"></div>
          <div class="BindingAccount-code">
            <div><input v-model="models.ValidCode" :placeholder="$t('placeholders.VerificationCode')" type="text" /></div>
            <div>
              <img :src="ValidImg" @click="changImg" />
            </div>
          </div>
          <div class="border_bottom"></div>
          <div @click="Verify" class="BindingAccount-btn">{{ $t("system.NextStep") }},{{ $t("system.Verify") }}{{ $t("Categorys." + AuthCode) }}</div>
        </div>
        <div class="BindingAccount-wrapper" v-if="Step == 2">
          <div style="text-align:center;padding: 0.532rem 0;">
            <div style="font-size: 0.478rem;">{{ $t("system.Verify") }}{{ $t("Categorys." + AuthCode) }}</div>
            <div style="font-size: 0.372rem; color: #666;margin-top:0.266rem">{{ $t("system.Verify") }}{{ $t("Categorys." + AuthCode) }}{{ models.UserAct }}</div>
          </div>
          <div class="BindingAccount-code" style="margin-bottom:0.133rem">
            <div><input v-model="models.UserCode" :placeholder="$t('placeholders.MessageAuthenticationCode')" type="text" /></div>
            <div>
              <label
                @click="Verify"
                style="display:inline-block;text-align: center;border-radius:0.133rem;min-width:1rem;height:1.064rem;line-height:1.064rem;background-color: #12a3ff;color: #fff;font-size: 0.452rem"
                >{{ $t(textCode) }}</label
              >
            </div>
          </div>
          <div class="border_bottom"></div>
          <div @click="Confirm" class="BindingAccount-btn">{{ $t("share.FinishBtn") }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .navBar {
    font-size: 0.425rem;
    height: 1.489rem;
    line-height: 1.489rem;
    padding: 0 0.266rem;
    position: relative;
    color: #fff;
    background-color: #12a3ff;
  }

  .navBar > div:nth-child(2) {
    text-align: center;
    width: 5.32rem;
    margin: 0 auto;
  }

  .navBar > div:last-child {
    color: #fff;
    position: absolute;
    right: 0.266rem;
    top: 0;
    width: 2.66rem;
    text-align: right;
  }

  .back {
    width: 1.33rem;
    position: absolute;
    bottom: 0;
  }

  .navBar img {
    width: 0.372rem;
    margin-bottom: -0.106rem;
  }
  .page-content {
    top: 2.12rem;
  }

  .BindingAccount {
    background: #fff;
    height: 100%;
    padding: 0 0.532rem;
  }

  .BindingAccount-title {
    font-size: 0.478rem;
    text-align: center;
    padding: 0.532rem 0;
  }

  .BindingAccount-account {
    height: 1.064rem;
    line-height: 1.064rem;
  }

  .BindingAccount-wrapper input {
    border: none;
    height: 100%;
    width: 100%;
  }

  .BindingAccount-code {
    position: relative;
  }

  .BindingAccount-code > div {
    height: 1.064rem;
    line-height: 1.064rem;
  }

  .BindingAccount-code > div:first-child {
    margin-right: 2.926rem;
  }

  .BindingAccount-code > div:nth-child(2) {
    position: absolute;
    top: 0;
    right: 0;
    width: 2.66rem;
  }

  .BindingAccount-code img {
    width: 100%;
    vertical-align: middle;
  }

  .BindingAccount-btn {
    margin: 0.798rem auto 0 auto;
    text-align: center;
    width: 7.98rem;
    color: #ffffff;
    background-color: #ff8010;
    height: 1.064rem;
    line-height: 1.064rem;
    border-radius: 0.106rem;
  }
</style>
<script>
  import sideService from "@/service/sideService";
  import navBar from "../../modules/navBar.vue";
  export default {
    name: "",
    data() {
      return {
        judgeCode: true,
        textCode: "system.TestGetCode",
        Step: 1,
        TotalStep: 2,
        ValidImg: "",
        models: {
          AuthType: "",
          UserAct: "",
          ValidCode: "",
          ValidID: "",
          UserCode: "",
        },
      };
    },
    computed: {
      AuthTypes() {
        return this.$store.getters.categorys.AuthType;
      },
      computed: {
        UserID() {
          return this.profile.UserID;
        },
      },
      AuthCode() {
        return this.$route.query.AuthCode;
      },
    },
    mounted() {
      let __self = this;
      __self.ValidImg = sideService.getValidImageUrl();
      __self.models.AuthType = __self.$route.query.AuthType;
      $(window).bind("popstate", function(e) {
        if (__self.Step > 1) {
          __self.Step--;
        }
      });
    },
    components: {
      navBar,
    },
    methods: {
      changImg() {
        let __self = this;
        __self.ValidImg = sideService.getValidImageUrl();
      },
      back() {
        let __self = this;
        history.back();
      },
      AuthTypeName(AuthType) {
        let __self = this;
        let result = _.find(__self.AuthTypes, o => {
          return o.CategoryID == AuthType;
        });
        if (result) {
          return result.CategoryTitle;
        } else {
          return __self.$t("mall.Phone");
        }
      },
      Verify() {
        let __self = this;
        if (__self.models.AuthType == 10222) {
          if (__self.models.UserAct == "") {
            return $utils.fail(__self.$t("share.fail.PhoneBinding"), "fail");
          }
          if (!$utils.RegExp.MobileReg.test(__self.models.UserAct)) {
            return $utils.fail(__self.$t("share.fail.Phone"), "fail");
          }
        } else if (__self.models.AuthType == 10220) {
          if (__self.models.UserAct == "") {
            return $utils.fail(__self.$t("share.fail.EmailBinding"), "fail");
          }
          if (!$utils.RegExp.EmailReg.test(__self.models.UserAct)) {
            return $utils.fail($t("share.fail.Email"), "fail");
          }
        }
        if (__self.models.ValidCode == "") {
          return $utils.fail(__self.$t("share.fail.VerificationCode"), "fail");
        }
        if (!__self.judgeCode) {
          return $utils.fail(__self.$t("share.fail.VerificationTime"), "fail");
        }
        __self.judgeCode = false;
        let $time = 60;
        function run() {
          __self.textCode = __self.$t("system.Sent") + "(" + --$time + ")";
          if ($time <= 0) {
            clearInterval(__self.setInterval);
            __self.textCode = __self.$t("system.TestGetCode");
            __self.judgeCode = true;
          } else {
            __self.judgeCode = false;
          }
        }
        let data = {
          AuthType: __self.models.AuthType,
          UserID: __self.UserID,
          UserAct: __self.models.UserAct,
          ValidCode: __self.models.ValidCode,
        };
        UserService.authSendCode(data).then(json => {
          if (json.isSucc) {
            __self.setInterval = setInterval(run, 1000);
            this.$root.$toast.success(__self.$t("share.succ.VerificationSucc"), "succ");
            __self.models.ValidID = json.result;
            if (__self.Step < __self.TotalStep) {
              __self.Step++;
              history.pushState({}, __self.Step, location.href);
            }
          }
          __self.judgeCode = true;
        });
      },
      Confirm() {
        let __self = this;
        if (__self.models.UserCode == "") {
          return $utils.fail(__self.$t("share.fail.DynamicCode"), "fail");
        }
        let data = {
          ValidID: __self.models.ValidID,
          ValidCode: __self.models.UserCode,
        };
        UserService.authBind(data).then(json => {
          if (json.isSucc) {
            this.$root.$toast.success(json.data.message, "succ");
            setTimeout(function() {
              __self.$router.push({
                path: "/system/user/account",
              });
            }, 1000);
          }
        });
      },
    },
  };
</script>
